import { useMutation } from '@apollo/client';
import { Button, ModalContent } from '@sandtech-hub-monorepo/ui-kit';
import { BulbIcon } from '@sandtech-hub-monorepo/ui-kit-site';
import { ReactComponent as DocumentCheckIcon } from '../../../../assets/Icons/file-check.svg';
import {
  GetViewerProgramEnrollmentsWithApplicationDocument,
  ManagePersonaInquiryDocument,
  PersonaInquiryAction,
  PersonaInquiryType,
} from '@sandtech-hub-monorepo/ehub-client';
import { Application } from '../../types';

interface PriorLearningModalProps {
  close: () => void;
  referenceId: string;
  application: Application;
}

export const PriorLearningModal = ({
  close,
  application,
}: PriorLearningModalProps) => {
  const [managePersonaInquiry, { loading }] = useMutation(
    ManagePersonaInquiryDocument,
    {
      onCompleted: (data) => {
        if (data.managePersonaInquiry.redirectUrl) {
          window.open(data.managePersonaInquiry.redirectUrl, '_blank');
          close();
        }
      },
      onError: (error) => {
        console.error('Failed to manage Persona inquiry:', error);
      },
      refetchQueries: [GetViewerProgramEnrollmentsWithApplicationDocument],
    }
  );

  return (
    <ModalContent>
      <div className="flex flex-col items-center text-center gap-6 max-w-[470px] mx-auto">
        <div className="flex flex-col gap-4 items-center">
          <div className="p-6 bg-primary/20 rounded-full text-primary mx-auto mb-2">
            <DocumentCheckIcon height="48" width="48" />
          </div>
          <h2 className="text-primary font-semibold text-2xl">
            Request Prior Learning
          </h2>
          <div className="text-foreground text-base text-center">
            Please submit transcripts or documentation for any prior
            university-level education you would like SET to consider.
          </div>
        </div>

        <div className="bg-accent flex gap-6 items-center px-6 py-4 rounded-lg w-full">
          <div className="bg-background rounded-full p-3 text-primary shrink-0">
            <BulbIcon />
          </div>
          <div className="text-foreground text-sm text-left">
            This will open a secure page on our partner service{' '}
            <strong>Persona</strong>. You'll be redirected outside this app to
            complete this step.
          </div>
        </div>

        <div className="flex justify-center">
          <Button
            onClick={() =>
              managePersonaInquiry({
                variables: {
                  input: {
                    programApplicationId: application.id,
                    inquiryType: PersonaInquiryType.PriorLearning,
                    action: PersonaInquiryAction.Generate,
                  },
                },
              })
            }
            disabled={loading}
          >
            {loading ? 'Opening upload page...' : 'Upload now'}
          </Button>
        </div>
      </div>
    </ModalContent>
  );
};
